import * as yup from 'yup';

export type Affiliate = {
  name: string;
  started: string;
  account: string;
  accountNumber: string;
  renews: string;
  commissions: string;
};

export enum PayoutType {
  PayPal = 'paypal',
  Not_Selected = 'not_selected',
}

export type AffiliatePayoutSettings = {
  affiliate_payout_method_id: PayoutType;
  affiliate_payout_address: string | null;
};

export const affiliatePayoutSettingsSchema = yup.object({
  affiliate_payout_method_id: yup
    .mixed<PayoutType>()
    .oneOf(Object.values(PayoutType))
    .required('Payout type is required'),
  affiliate_payout_address: yup
    .string()
    .nullable()
    .when('affiliate_payout_method_id', {
      is: PayoutType.PayPal,
      then: (schema) =>
        schema
          .required('PayPal email is required when payout type is PayPal')
          .email('Invalid email format'),
      otherwise: (schema) => schema.nullable(),
    }),
});

export type AffiliatePayoutSettingsFormData = yup.InferType<
  typeof affiliatePayoutSettingsSchema
>;

export type TAffiliateAccountProductLink = {
  id: number;
  title: string;
  description: string;
  display_name_web: string;
  display_name_app: string;
  is_visible_on_web: boolean;
  account_benefits: string;
  category: string;
  is_bundle: boolean;
  type: string;
  account_type: string;
  billing_plan: {
    id: number;
    first_price: number;
    first_period_value: number;
    first_period_unit: string;
    second_price: number;
    rebill_times_type: string;
    rebill_times_unit: number;
    second_period_value: number;
    second_period_unit: string;
  };
  addon_type: string;
  addon_lifetime_performance_account_package_id: number;
  addon_trading_days_required: number;
  addon_discount_percent: number;
  addon_valid_for_days: number;
  addon_extra_amount_allowed_payout: number;
  addon_new_percent_override_default: number;
  addon_extra_allowed_payout_time: string;
  addon_disable_percent_default: boolean;
  addon_packages: number[];
  allow_reset_of_packages: number[];
  market_data_type: string;
  addon_performance_account_fee_option: string;
  addon_additional_drawdown_option: number;
  affiliate_eligible: boolean;
  affiliate_commission_percentage: number;
  affiliate_links: {
    checkout_link: string;
    checkout_short_link: string;
  };
};

export type TAffiliateAccountLinksResponse = {
  general_affiliate_link: string;
  account_links: TAffiliateAccountProductLink[];
};

export type TAffiliateCheckoutPayload = {
  email: string;
  password: string;
  product_id: number;
  addons: number[];
  billing_info: {
    first_name: string;
    last_name: string;
    street: string;
    city: string;
    country: string;
    state?: string;
    zip_code?: string;
    phone_number: string;
  };
  terms_accepted: Array<{
    type: string;
    content: string;
  }>;
  trading_platform: string;
  referral_source: string;
  promo_code?: string;
  additional_charges: string[];
  affiliate_referral_code: string;
  payment_gateway: string;
};

export type TAffiliateCheckoutResponse = {
  id: string;
  checkout_url: string;
  invoice_id: number;
  message: string;
};
